// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"d406d4d5","365":"471d5f54","496":"5c9f8224","650":"d29a9b3c","654":"92e75dd2","740":"7fa5f671","991":"e57df286"}[chunkId] + ".chunk.js";
};